import { FC, createContext, ReactNode } from "react";
import { Dispatch, SetStateAction, useContext } from "react";

type GiftcardsRequestPayload = {
  name?: string;
  Page?: number;
  PageSize?: number;
  categoryCode?: string;
  sortBy?: "best_seller";
};

type GiftcardsListingContextType = {
  filters: GiftcardsRequestPayload;
  setFilters: Dispatch<SetStateAction<GiftcardsRequestPayload>>;
};

const GiftcardsListingContext = createContext<null | GiftcardsListingContextType>(null);

const GiftcardsListingProvider: FC<{ value: GiftcardsListingContextType; children: ReactNode }> = ({ value, children }) => {
  return <GiftcardsListingContext.Provider value={value}>{children}</GiftcardsListingContext.Provider>;
};

const useGiftcardsListing = () => {
  const context = useContext(GiftcardsListingContext);
  if (!context) throw new Error("Illegal Usage of Context outside the DiscountsListingContext");
  return context;
};


export {GiftcardsListingProvider,useGiftcardsListing};